module.exports = __webpack_public_path__ + "img/rep-aiken.94cb0c96.jpg";